import React from "react";
import PropTypes from "prop-types";
import { PropertyStatusBadgeWrapper } from "./PropertyStatusBadge.styles";

/**
 * Componente de badge para mostrar el estado de la propiedad
 * Basado en el CustomBadge de habi-brokers
 */
const PropertyStatusBadge = ({
  label = null,
  backgroundColor = null,
  textColor = null,
  fontSize = "14px",
  toolTipMessage = null,
  $isFirst = false,
  $isLast = false,
  $hasMultipleBadges = false
}) => {
  if (!label) return null;

  return (
    <PropertyStatusBadgeWrapper
      $backgroundColor={backgroundColor}
      $textColor={textColor}
      $fontSize={fontSize}
      $isFirst={$isFirst}
      $isLast={$isLast}
      $hasMultipleBadges={$hasMultipleBadges}
      title={toolTipMessage}
    >
      {label}
    </PropertyStatusBadgeWrapper>
  );
};

PropertyStatusBadge.propTypes = {
  label: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  toolTipMessage: PropTypes.string,
  $isFirst: PropTypes.bool,
  $isLast: PropTypes.bool,
  $hasMultipleBadges: PropTypes.bool,
};

export default PropertyStatusBadge;

